import {db} from "../../../Firebase";
import * as firebase from "firebase";
import {SHOW_SNACKBAR} from "../../type";


/**
 * This function will add a recipe's rate value,  if the current user already have rate it,
 * the old one will be overwritten
 * @param values    {object}: contains recipe's name, user's pseudo and the rating value
 */
export const addRating=   ( values )=> async dispatch => {
    try {
        let id="";
        let ancientRate = null;
        await db.collection("recipes").where("name", "==", values.recipeName).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                id = doc.id;

                //if this recipe have already some rates, we search if the current user already add one
                if(doc.data().ratings){
                    ancientRate = doc.data().ratings.find(element => element.user === values.userPseudo);
                }
            });
        });

        let recipeRef = db.collection("recipes").doc(id);
        if (ancientRate) {  //if the current user already add a rate for this recipe, we remove the old one
            await recipeRef.update({ratings: firebase.firestore.FieldValue.arrayRemove(ancientRate)});
        }

        await recipeRef.update({ratings: firebase.firestore.FieldValue.arrayUnion({rating:values.rating, user:values.userPseudo})});
        dispatch({type: SHOW_SNACKBAR, payload: {txt: 'votre note a été prise en compte', variant: "success"}});

    }
    catch(e){
        dispatch({type: SHOW_SNACKBAR, payload: {txt: "une erreur est survenue lors de l'ajout de votre note", variant: "error"}});
    }
};


